/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
export class HelperFunctions {
	static mergeObj(source: any, value: any) {
		for (const propName in value) {
			if (value[propName] !== "") {
				if (
					typeof value[propName] === "object" &&
					source.hasOwnProperty(propName)
				) {
					source[propName] = this.mergeObj(source[propName], value[propName]);
				} else if (value[propName] === "true") {
					source[propName] = true;
				} else if (value[propName] === "false") {
					source[propName] = false;
				} else {
					source[propName] = value[propName];
				}
			}
		}
		return source;
	}
}
export const formatHtml = (html: string) => {
	let updatedHtml = html;
	updatedHtml = updatedHtml.replace(/className/g, "class");
	return updatedHtml;
};

export const copyToClipboard = async (text: string) => {
	await navigator.clipboard.writeText(text);
};

export const getSelectedLabels = (
	options: any[],
	selectedIds: string[],
	idKey: string,
	labelKey: string
) => {
	if (!selectedIds || selectedIds.length === 0) return "";
	if (selectedIds.includes("") || selectedIds.length == options.length) {
		return "All";
	}

	return options
		.filter((o) => selectedIds.includes(o[idKey].toString()))
		.map((o) => o[labelKey])
		.join(", ");
};

export const downloadBase64File = (
	base64Data: string,
	fileName: string,
	mimeType: string
) => {
	const byteCharacters = atob(base64Data);
	const byteNumbers = new Array(byteCharacters.length);

	for (let i = 0; i < byteCharacters.length; i++) {
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}

	const byteArray = new Uint8Array(byteNumbers);
	const blob = new Blob([byteArray], { type: mimeType });
	const url = window.URL.createObjectURL(blob);

	const link = document.createElement("a");
	link.href = url;
	link.download = fileName;
	link.click();
	window.URL.revokeObjectURL(url);
};
